import React from 'react'
import RosterAndScheduleHomeNavigation from './RosterAndScheduleHomeNavigation'
import './StatsAndStandingsHome.css'
import Banner from './Banner'

const RosterAndScheduleHome = () => {
	return (
		<div>
			{/* StatsAndStandingsHomeNavigation contains HomeHeader (just says Stats & Standings)
			and the HomeNavLinks (which is the ADMIN button on the far right) */}
			<RosterAndScheduleHomeNavigation />
			<Banner />
			{/* <div className='rem'>
				<Footer />
			</div> */}
		</div>
	)
}

export default RosterAndScheduleHome
